export function Graph() {
    this.clusters = [];
    this.nodes = {};
}